import { render, staticRenderFns } from "./consult.vue?vue&type=template&id=fd4cee96&scoped=true"
import script from "./consult.vue?vue&type=script&lang=js"
export * from "./consult.vue?vue&type=script&lang=js"
import style0 from "./consult.vue?vue&type=style&index=0&id=fd4cee96&prod&lang=scss"
import style1 from "./consult.vue?vue&type=style&index=1&id=fd4cee96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd4cee96",
  null
  
)

export default component.exports